import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectIsEveryDocumentChecked = createSelector(
  [(store: RootState) => store.documentsSignerList.documents],
  (documents) => documents.every(({ checked }) => checked)
);
